import { FlashNoticeVariant } from 'components/FlashNotice'
import { showFlashNotice } from 'components/FlashNotice/duck/actions'

import { Corporate } from '../../../../../../../../entities-next/corporate'

export function successfulCorporateUpdateAction(corporate: Pick<Corporate, 'name'>) {
  return showFlashNotice({
    message: `Corporate "${corporate.name}" successfully updated!`,
    autoHide: true,
    variant: FlashNoticeVariant.success,
  })
}

export function successfulCorporateCreationAction(corporate: Pick<Corporate, 'name'>) {
  return showFlashNotice({
    message: `Corporate "${corporate.name}" successfully created!`,
    autoHide: true,
    variant: FlashNoticeVariant.success,
  })
}

export function failedCorporateOperationAction(e: Error) {
  return showFlashNotice({
    message: e.message,
    autoHide: false,
    variant: FlashNoticeVariant.error,
  })
}
